import toast from 'react-hot-toast';
import { ApiEndpoints } from '../../services/endpoints';
import { BASE_URL } from '../../services/service';
import { STOREFRONT_FETCH_STORE, LOADING_STOREFRONT, UPDATE_STORE_CART } from '../actionTypes';
import axios from 'axios';

export const fetchStoreInfo = (storeName) => async (dispatch) => {
    dispatch({ type: LOADING_STOREFRONT, payload: true });
    try {
        const { data: response } = await axios.get(
            `${BASE_URL}${ApiEndpoints.GET_STORE}?store_name=${storeName}`,
        );
        dispatch({ type: STOREFRONT_FETCH_STORE, payload: response.data });
    } catch (error) {
        const message = error.message ? error.message : 'Network Error';
        toast.error(message, { position: 'top-right' });
    } finally {
        dispatch({ type: LOADING_STOREFRONT, payload: false });
    }
};

export const updateStoreCart = (item) => async (dispatch) => {
    localStorage.setItem('store_cart', JSON.stringify(item));
    dispatch({ type: UPDATE_STORE_CART, payload: item });
};
